import axios from 'axios';
import config from '@/vue-caas/config/config.js';
import {
  isEmptyProcessWindowList,
  changeProcessShareFlag,
  compareTableData,
} from '@/vue-caas/utils/process';

const baseURI = config.setupApiUrl;

const converterStoreModule = {
  // namespaced: false,

  state: {
    converterList: [],
    converterSelectBoxList: [],
    converterDetail: {},
    converterId: '',
    dataSet01Source: [],
    searchBy: {},
    converterChange: {},
    aiClientList: [],
  },
  mutations: {
    SET_STORE_CONVERTER_LIST(state, allSourceList) {
      let converterList = [];
      let aiClientList = [];

      allSourceList.forEach((tmpCvt) => {
        if (tmpCvt.aiEndpoint) {
          aiClientList.push(tmpCvt);
        } else {
          converterList.push(tmpCvt);
        }
      });

      if (
        JSON.stringify(state.dataSet01Source) !== JSON.stringify(converterList) &&
        !isEmptyProcessWindowList()
      ) {
        changeProcessShareFlag('CVT');
      }

      state.converterList = converterList;
      state.aiClientList = aiClientList;
      state.dataSet01Source = converterList;
    },
    SET_STORE_CONVERTER_SELECT_BOX_LIST(state, converterSelectBoxList) {
      state.converterChange = compareTableData(
        state.converterSelectBoxList,
        converterSelectBoxList,
        'cvtrId'
      );
      state.converterSelectBoxList = converterSelectBoxList.map((item) => {
        return {
          ...item,
          text: item.cvtrNm,
          value: item.cvtrId,
        };
      });
    },
    SET_STORE_CONVERTER(state, converterDetail) {
      state.converterDetail = converterDetail;
    },
    SET_STORE_CONVERTER_ID(state, id) {
      state.converterId = id;
      if (!isEmptyProcessWindowList()) {
        changeProcessShareFlag('CVT');
      }
    },
    // 021.11.19 203728 SPKA-242 filter the converter list
    SET_STORE_SEARCH_CONVERTER(state, searchBy) {
      let datarows = state.dataSet01Source;
      state.searchBy = searchBy;
      let filterBy = state.searchBy;
      let listResult = [];
      if (filterBy != null) {
        let searchBy = filterBy.searchBy;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }
        listResult = datarows.filter((item) => {
          if (searchBy == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[searchBy] == 'string') {
              let propValue = item[searchBy].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[searchBy] == 'number') {
              let propValue = item[searchBy].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }

          return false;
        });
      }
      state.converterList = listResult;
    },
  },
  actions: {
    getConverterList: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/cvtr/list', params)
        .then((response) => {
          commit('SET_STORE_CONVERTER_LIST', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },
    // 021.11.19 203728 SPKA-242 filter the converter list
    setFilterConverter: async ({ commit }, searchBy) => {
      commit('SET_STORE_SEARCH_CONVERTER', searchBy);
    },
    getConverterSearchList: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/cvtr/list/search', params)
        .then((response) => {
          commit('SET_STORE_CONVERTER_LIST', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },
    // 2021.10.26 203728 SPKA-224 return data not save store
    getCvtrGrpList: async ({ commit }, params) => {
      return await axios
        .post(baseURI + '/cvtr/list', params)
        .then((response) => {
          commit('SET_STORE_CONVERTER_SELECT_BOX_LIST', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },

    getConverterDetail: async ({ commit }, params) => {
      await axios
        .get(baseURI + `/cvtr/dtl/${params}`, params)
        .then((response) => {
          commit('SET_STORE_CONVERTER', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },

    insertConverter: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/cvtr/insert', params)
        .then((response) => {
          // alert(response.data);
          // commit('SET_STORE_CONVERTER_LIST', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },

    insertConverterFromProcSetup: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/cvtr/insert', params)
        .then((response) => {
          commit('SET_STORE_CONVERTER_ID', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },

    editConverter: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/cvtr/update', params)
        .then((response) => {
          // alert(response.data);
          // commit('SET_STORE_CONVERTER_LIST', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },

    editConverterFromProcSetup: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/cvtr/update', params)
        .then((response) => {
          // alert(response.data);
          commit('SET_STORE_CONVERTER_ID', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },

    deleteConverter: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/cvtr/delete', params)
        .then((response) => {
          // alert(response.data);
          // commit('SET_STORE_CONVERTER_LIST', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },
  },
  getters: {
    converterList: (state) => state.converterList,
    converterSelectBoxList: (state) => state.converterSelectBoxList,
    converterDetail: (state) => state.converterDetail,
    converterId: (state) => state.converterId,
    converterChange: (state) => state.converterChange,
  },
};

export default converterStoreModule;
